'use strict';

const { h, Component } = require('phy');
const { hydrate } = require('@grpn/hydration');
const { Translate } = require('@grpn/preact-l10n');

const { publish } = require('../../support/event-observer');
const getUniqueArrayFromObjects = require('../../support/get-unique-array-from-objects');

class MerchantFilter extends Component {
  constructor(props, ...rest) {
    super(props, ...rest);

    this.keyUpHandlerFilter = this.keyUpHandlerFilter;
  }
  render({ coupons }) {
    const offerTypes = getUniqueArrayFromObjects(coupons, c => c.offerType);

    return h('.merchant-filter', [
      h('ul.merchant-filter-list', [
        h('li.merchant-filter-item', [
          h('input.merchant-filter-input', {
            id: `merchant-filter-all`,
            type: 'radio',
            name: 'group',
            checked: true,
            onChange: this.changeHandlerFilter(null),
          }),
          h(
            'label.merchant-filter-label',
            {
              for: `merchant-filter-all`,
              tabindex: 0,
              onKeyUp: this.keyUpHandlerFilter,
            },
            h(Translate, 'js.modules.shared.AllFilter')
          ),
        ]),
        ...offerTypes.map((type, index) =>
          h('li.merchant-filter-item', [
            h('input.merchant-filter-input', {
              id: `merchant-filter-${index}`,
              type: 'radio',
              name: 'group',
              onChange: this.changeHandlerFilter(type),
            }),
            h(
              'label.merchant-filter-label',
              {
                for: `merchant-filter-${index}`,
                tabindex: 0,
                onKeyUp: this.keyUpHandlerFilter,
              },
              h(Translate, this.getLabelResourceKey(type))
            ),
          ])
        ),
      ]),
    ]);
  }

  keyUpHandlerFilter(ev) {
    if (ev.keyCode === 13) {
      ev.target.click();
    }
  }

  getLabelResourceKey(type) {
    const key = type.replace(/Online|Instore/, '');

    return `js.modules.shared.OfferTypeFilter.${key}`;
  }

  changeHandlerFilter(offerType) {
    return () => publish('@filter', { offerType });
  }
}

module.exports = hydrate('MerchantFilter', MerchantFilter);
